import { Injectable, inject } from "@angular/core";

import { MenuAboutType } from "@hermes/api-model-menu";
import {
    AnalyticsService,
    EVENT_UAEVENT,
    formatPimCodeForAnalytics,
} from "@hermes/hermes-web-fragments-analytics";

import { getFormattedEntryName } from "../helpers/menu.helper";

import { MenuAnalytics, SHOP_NAV_TRAY_EVENT } from "../models/analytics.model";
import {
    MenuDiscoveryItem,
    MenuEntryItemWithEdito,
} from "../models/menu.model";

@Injectable()
export class MenuAnalyticsService {
    private analyticsService = inject(AnalyticsService);

    public sendAnalyticsOnMenuEditoClick(
        menuEntry: MenuEntryItemWithEdito,
    ): void {
        this.analyticsService.sendRawData<MenuAnalytics>({
            event: EVENT_UAEVENT,
            eventcategory: SHOP_NAV_TRAY_EVENT,
            eventaction: `Lv1_${formatPimCodeForAnalytics(menuEntry.pimCode)}`,
            eventlabel: `Lv2_${formatPimCodeForAnalytics(menuEntry.pimCode)}_EDITO_IMG`,
        });
    }

    public sendAnalyticsOnMenuLinkClick(
        primaryEntry: MenuDiscoveryItem | undefined,
        secondaryEntry: MenuDiscoveryItem | undefined,
        menuEntry: MenuDiscoveryItem | undefined,
    ): void {
        if (!menuEntry) {
            return undefined;
        }

        const getAnalyticsId = (
            entry: MenuDiscoveryItem | undefined,
        ): string | undefined => {
            if (!entry) {
                return undefined;
            }

            const useFormattedName =
                menuEntry.type === MenuAboutType.TYPE_INTERNAL_LINK ||
                menuEntry.type === MenuAboutType.TYPE_EXTERNAL_LINK ||
                menuEntry.type === MenuAboutType.TYPE_BUTTON;

            if (useFormattedName) {
                return getFormattedEntryName(entry);
            }

            return "pimCode" in entry ? entry.pimCode : undefined;
        };

        const analyticsData: MenuAnalytics = {
            event: EVENT_UAEVENT,
            eventcategory: SHOP_NAV_TRAY_EVENT,
            eventaction: "",
        };

        if (primaryEntry && secondaryEntry) {
            analyticsData.eventaction = `Lv1_${formatPimCodeForAnalytics(getAnalyticsId(primaryEntry))}`;
            analyticsData.eventlabel = `Lv2_${formatPimCodeForAnalytics(getAnalyticsId(secondaryEntry))}`;
            analyticsData.event_lv3 = `Lv3_${formatPimCodeForAnalytics(getAnalyticsId(menuEntry))}`;
        } else if (primaryEntry) {
            analyticsData.eventaction = `Lv1_${formatPimCodeForAnalytics(getAnalyticsId(primaryEntry))}`;
            analyticsData.eventlabel = `Lv2_${formatPimCodeForAnalytics(getAnalyticsId(menuEntry))}`;
            analyticsData.event_lv3 = undefined;
        } else {
            analyticsData.eventaction = `Lv1_${formatPimCodeForAnalytics(getAnalyticsId(menuEntry))}`;
        }

        this.analyticsService.sendRawData<MenuAnalytics>(analyticsData);
    }
}
